<template>
  <div>
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <AgreementForm
            ref="baseFormRef"
            :fetchFormData="fetchFormData"
            :isDisabledForm="isDisabledForm"
            :isDisabledPricingRule="isDisabledPricingRule"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            交易明细
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs type="card" v-model="tabActiveName" class="common-tab">
            <el-tab-pane label="产品明细" name="first">
              <div class="detail">
                <AgreementTable
                  :companyCode="companyCode"
                  ref="orderDetailListRef"
                  :detailPageData="fetchFormData"
                  :orderDetailList="orderDetailList"
                  @closeTableHandler="closeTableHandler"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane label="关联明细" name="seconed">
              <div class="detail">
                <RelationInfoTable
                  :isEdit="isEdit"
                  ref="relationInfo"
                  :contractStatus="contractStatus"
                  :defaultData="orderContractRelationshipList"
                ></RelationInfoTable>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="fileTableRef"
            :attachments="attachmentList"
            :isShowDownBtn="isShowDownBtn"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 底部按钮组 -->
    <AgreementBtn :contractStatus="contractStatus" @btnHandler="btnGroupHandler" />
  </div>
</template>

<script>
  import AgreementForm from './components/AgreementForm/index.vue';
  import AgreementTable from './components/AgreementTable/index.vue';
  import AgreementBtn from './components/FooterBtnGroup/AgreementBtn.vue';
  import RelationInfoTable from './components/RelationInfoTable/index.vue';
  import btnMixin from './btnMixin.js';
  import dataMixin from './dataMixin.js';
  import wumaoMixins from '@/common/mixins/wumaoMixins';
  export default {
    name: 'wumaoAgreementCreate',
    mixins: [btnMixin, dataMixin, wumaoMixins],
    data() {
      return {
        activeNames: ['1', '2', '3'],
        attachments: [],
        isShowDownBtn: false,
        contractStatus: '',
        companyCode: '', // TODO 监听表单中的数据
        orderContractRelationshipList: [],
        isEdit: false,
        tabActiveName: 'first',

        // 新增
        orderDetailList: [],
        type: 'agreement',
        isDisabledPricingRule: null,
      };
    },
    mounted() {
      if (this.$route.query.status == 'create') {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
    },
    methods: {
      btnGroupHandler(type, params) {
        console.log(type);
        this[type](params);
      },
      closeTableHandler(tableData = []) {
        // 处理定价
        const isFixedPriceResult = tableData.some((item) => item.isFixedPrice == '0');
        this.isDisabledPricingRule = isFixedPriceResult;
      },
    },
    components: {
      AgreementForm,
      AgreementTable,
      AgreementBtn,
      RelationInfoTable,
    },
  };
</script>

<style></style>
